import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './ContactModal.css';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import {
  Box,
  ModalClose,
  Step,
  StepIndicator,
  Stepper,
} from '@mui/joy';
import AddressPage from './pages/AddressPage';
import StancePage from './pages/StancePage';
import ContactPage from './pages/ContactPage';

function ContactModal({ bill, open, setOpen }) {
  const [representative, setRepresentative] = useState({});
  const [address, setAddress] = useState('');
  const [stance, setStance] = useState('');
  const [page, setPage] = useState('address');

  async function findRepresentative(address) {
    if (address.length > 0) {
      var rep = await fetch(`/api/member/address/${address}`).then(
        (response) => response.json()
      );
      setRepresentative(rep);
    }
  }

  useEffect(() => {
    findRepresentative(address);
  }, [address]);

  useEffect(() => {
    return () => {
      setPage('address');
      setRepresentative({});
      setStance('');
      setAddress('');
    };
  }, []);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalDialog size="lg" sx={{ minWidth: '1000px' }}>
        <ModalClose />
        <Stepper sx={{ width: '100%' }}>
          <Step
            orientation="vertical"
            sx={{ textAlign: 'center' }}
            indicator={
              <StepIndicator variant="solid" color="primary">
                1
              </StepIndicator>
            }
          >
            Enter your address
          </Step>
          <Step
            orientation="vertical"
            sx={{ textAlign: 'center' }}
            indicator={
              <StepIndicator
                variant={
                  page === 'stance' || page === 'contact' ? 'solid' : 'outlined'
                }
                color="primary"
              >
                2
              </StepIndicator>
            }
          >
            Select your stance
          </Step>
          <Step
            orientation="vertical"
            sx={{ textAlign: 'center' }}
            indicator={
              <StepIndicator
                variant={page === 'contact' ? 'solid' : 'outlined'}
                color="primary"
              >
                3
              </StepIndicator>
            }
          >
            Voice your thoughts
          </Step>
        </Stepper>
        <Box>
          {page === 'address' ? (
            <AddressPage
              setOpen={setOpen}
              setPage={setPage}
              setAddress={setAddress}
            />
          ) : page === 'stance' ? (
            <StancePage setPage={setPage} setStance={setStance} bill={bill} />
          ) : (
            <ContactPage
              setOpen={setOpen}
              representative={representative}
              stance={stance}
              bill={bill}
              address={address}
            />
          )}
        </Box>
      </ModalDialog>
    </Modal>
  );
}

// Prop types for our Component
ContactModal.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  bill: PropTypes.object.isRequired,
};

export default ContactModal;
